import appsClinicianOASAS from './dashboard-oasas'

export default [...appsClinicianOASAS]